<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="reportsVisible = !reportsVisible">
                  {{ $t('contract_reports.area_work_reports') }} ({{ workReports.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="reportsVisible = !reportsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:reportsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: reportsVisible }">
          <area-work-list :results="workReports" :showAdd="false"/>
      </div>
      <hr class="report-divider nopads">
  </div>
</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import {timeUtils} from "../mixins/TimeUtils";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import AreaWorkList from "@/components/area/areawork/AreaWorkList";
export default {
    name: "ContractAreaWorkReports",
    mixins: [restApi, timeUtils],
    components: {AreaWorkList, Vue3Datatable},
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        }
    },
    data() {
        return {
            loading: false,
            workReports: [],
            reportsVisible: false,
        }
    },
    computed: {
        fields() {
            return [
                {field: 'area', title: this.$t('work_report.area'), sort: true, headerClass: 'routa-table-header'},
                {field: 'task_type', title: this.$t('work_report.task_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'time', title: this.$t('work_report.time'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        searchParams() {
            this.fetchAreaWorkReports()
        }
    },
    mounted() {
        this.fetchAreaWorkReports()
    },
    methods: {
        async fetchAreaWorkReports() {
            this.$emit('loading', true)
            this.loading = true
            const { data } = await this.axios.get('area/work', {
                params: {
                    from: new Date(this.searchParams.dateFrom).toISOString(),
                    to: new Date(this.searchParams.dateTo).toISOString(),
                    contract: this.searchParams.contract
                }
            }).catch(() => {});
            this.loading = false
            this.$emit('loading', false);
            this.workReports = data
        }
    }
}
</script>
